import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export const fetchExcludedList: IsActive.FilteredFetcher = IsActive.filteredWithoutCommunityFetchAction(
    Constants.FETCH_EXCLUDED_LIST,
    Constants.SERVER_RESOURCE,
  )

export const resetModal: Modal.Reset = Modal.resetModal(Constants.ADD_EXCLUDED_LIST)
export const toggleModal: Modal.Toggle = Modal.toggleModal(Constants.ADD_EXCLUDED_LIST)
export const updateModalField: Modal.Update = Modal.updateModal(Constants.ADD_EXCLUDED_LIST)

export const create: Modal.Submit<Types.ModalData> = (community: string, data: Types.ModalData) =>
  Request.requestActionCreator(Constants.ADD_EXCLUDED_LIST)({
    method: 'POST',
    payload: data,
    url: Constants.SERVER_RESOURCE,
  })
export const updateStatus: IsActive.UpdateStatusAction = (community: string, stateChange: IsActive.StateChange) =>
  Request.requestActionCreator(Constants.UPDATE_BLACKLIST)({
    method: 'PUT',
    payload: IsActive.asUpdateBody(stateChange),
    url: `${Constants.SERVER_RESOURCE}/${stateChange.props.dataItem.community_identifier}/${stateChange.id}`,
  })

export type UpdateSearchAction = (searchTerm: string) => any
export const updateSearch: UpdateSearchAction = (searchTerm: string) => ({
  term: searchTerm,
  type: Constants.UPDATE_BLACKLIST_SEARCH_STRING,
})



// WEBPACK FOOTER //
// ./src/pages/blacklists/actions.ts